import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterWoodstock() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-woodstock",
    name: "Painters Woodstock",
    location: "Woodstock, Cape Town",
    rating: 4.9,
    reviews: 173,
    specialties: ["Interior Painting", "Exterior Painting", "Commercial Projects", "Restoration Work"],
    image: "https://public.readdy.ai/ai/img_res/47ec51515a766423d3d2cd3d64792c4b.jpg",
    verified: true,
    yearsExperience: 16,
    website: "https://painterswoodstock.co.za/",
    email: "info@painterswoodstock.co.za",
    description: "Painters Woodstock is your premier painting contractor serving Woodstock and the surrounding Cape Town areas. With 16 years of experience, we specialize in both residential and commercial painting projects, including heritage restoration and modern transformations. Our team understands the unique character of Woodstock's diverse architecture, from historic buildings to contemporary developments. We deliver exceptional results using premium materials and expert techniques, whether you're renovating a Victorian cottage or updating a modern loft.",
    services: [
      "Interior House Painting",
      "Exterior House Painting",
      "Commercial Property Painting",
      "Heritage Building Restoration",
      "Industrial Space Painting",
      "Decorative Finishes",
      "Color Consultation",
      "Waterproofing Services",
      "Wall Repairs & Preparation",
      "Protective Coatings"
    ],
    serviceAreas: ["Woodstock", "Salt River", "Observatory", "Mowbray", "Rondebosch", "City Bowl", "Gardens"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20modern%20loft%20interior%20painted%20by%20professional%20painters%20in%20Woodstock%20Cape%20Town%2C%20trendy%20urban%20living%20space%20with%20fresh%20white%20walls%2C%20exposed%20brick%20features%2C%20quality%20paint%20finish%2C%20contemporary%20furniture%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work&width=400&height=300&seq=woodstock-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20building%20painting%20project%20in%20Woodstock%20Cape%20Town%2C%20historic%20Victorian%20building%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20urban%20artistic%20neighborhood%2C%20well-maintained%20heritage%20property&width=400&height=300&seq=woodstock-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Commercial%20office%20space%20painting%20in%20Woodstock%20Cape%20Town%2C%20professional%20painters%20working%20on%20creative%20business%20property%20interior%2C%20quality%20commercial%20paint%20finish%2C%20modern%20industrial%20design%2C%20organized%20work%20site&width=400&height=300&seq=woodstock-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20interior%20painting%20in%20Woodstock%20loft%20apartment%2C%20fresh%20painted%20walls%20with%20premium%20finish%2C%20contemporary%20industrial%20kitchen%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=woodstock-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Heritage%20building%20restoration%20painting%20in%20Woodstock%20Cape%20Town%2C%20professional%20painters%20working%20on%20historic%20property%20exterior%2C%20quality%20restoration%20paint%20finish%2C%20Victorian%20architecture%2C%20organized%20professional%20work%20site&width=400&height=300&seq=woodstock-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Creative%20studio%20space%20interior%20painting%20in%20Woodstock%20Cape%20Town%2C%20professional%20painting%20work%20in%20artistic%20workspace%2C%20quality%20finish%20for%20creative%20space%2C%20modern%20industrial%20design%2C%20clean%20professional%20application&width=400&height=300&seq=woodstock-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Emma Richardson",
        rating: 5,
        comment: "Outstanding work on our Woodstock loft renovation! The team understood our vision perfectly and delivered beautiful results. Professional, clean, and completed on schedule. Highly recommend for any urban property project."
      },
      {
        name: "David Jacobs", 
        rating: 5,
        comment: "Excellent service for our heritage building restoration. They took great care with the historic features while modernizing the interior. Expert craftsmanship and attention to detail throughout."
      },
      {
        name: "Lisa Chen",
        rating: 5,
        comment: "Very impressed with their commercial painting work. They painted our Woodstock office space and were respectful of our business operations. Quality finish and great communication from start to finish."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Woodstock | Professional Painting Services Cape Town | Heritage & Modern Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Woodstock offers professional painting services for residential and commercial properties in Woodstock, Cape Town. Specializing in heritage restoration, modern lofts, and commercial spaces. 16+ years experience. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Woodstock, house painters Woodstock, painting contractors Cape Town, heritage restoration, commercial painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20trendy%20building%20in%20Woodstock%20Cape%20Town%2C%20vibrant%20artistic%20urban%20neighborhood%20with%20colorful%20street%20art%20and%20mountain%20backdrop%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20industrial-modern%20architecture%2C%20bright%20natural%20lighting%2C%20high%20quality%20urban%20painting%20project&width=1200&height=600&seq=woodstock-painters-hero-main&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Woodstock</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Urban Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Woodstock is one of Cape Town's most dynamic neighborhoods, known for its vibrant arts scene, historic architecture, and modern developments. Our team has extensive experience working with the diverse range of properties in this area, from Victorian cottages and heritage buildings to contemporary lofts and commercial spaces. We understand the unique character of Woodstock and deliver painting solutions that enhance each property's individual style.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Heritage Restoration Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Many of Woodstock's buildings have significant historical value, requiring specialized restoration techniques and materials. Our team is experienced in heritage restoration work, understanding how to preserve original features while updating properties for modern living. We work carefully with historic surfaces, use appropriate materials, and maintain the architectural integrity of period buildings while delivering beautiful, durable results.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Modern & Commercial Projects</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Woodstock is also home to numerous modern developments, creative studios, and commercial spaces. We excel at contemporary painting projects, from sleek residential lofts to industrial-style offices and retail spaces. Our team understands modern design aesthetics and can execute everything from minimalist finishes to bold, creative color schemes. We work efficiently to minimize disruption to businesses and residents.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality & Craftsmanship</h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  We use only premium paints and materials, ensuring durability and beautiful finishes that last. Our team consists of skilled painters with years of experience, committed to delivering quality workmanship on every project. We take pride in our attention to detail, from thorough surface preparation to the final coat, and we stand behind our work with solid guarantees and excellent customer support.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20trendy%20building%20in%20Woodstock%20Cape%20Town%2C%20artistic%20urban%20neighborhood%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20modern%20industrial%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=woodstock-sidebar-image&orientation=landscape"
                      alt="Professional painters Woodstock residential commercial painting services Cape Town heritage restoration"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Woodstock</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Residential & Commercial Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services cover all aspects of residential and commercial projects in Woodstock. From heritage restorations to modern transformations, we provide comprehensive solutions that enhance aesthetics and protect your property investment.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} with premium materials and expert application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Excellence</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Transform your Woodstock property with our professional interior painting services. Whether you're updating a Victorian cottage, modernizing a loft, or refreshing a commercial space, we use premium paints that provide excellent coverage and durability. Our color consultation services help you choose the perfect palette that complements your property's unique character.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the importance of minimizing disruption, especially in occupied homes and operating businesses. Our team works efficiently and cleanly, respecting your space and schedule while delivering exceptional results.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior & Restoration Work</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in Woodstock requires expertise in both modern and heritage applications. We use premium exterior paints that resist fading, weathering, and urban pollution. For heritage buildings, we employ specialized restoration techniques and appropriate materials that preserve architectural integrity while providing modern protection.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our comprehensive exterior services include surface preparation, repairs, waterproofing, and protective coatings. We take special care with historic features, ensuring that restoration work maintains the building's character while delivering long-lasting results.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Woodstock</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Woodstock and surrounding areas. Each project demonstrates our commitment to quality workmanship and our expertise in both heritage restoration and modern applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Woodstock Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Woodstock have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Woodstock</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Woodstock property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Woodstock painting project. Our experienced team will assess your property and provide detailed recommendations.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
